'use client'
import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE__base_ui_components_react_checkbox_ad80fa33__ from "@base-ui-components/react/checkbox";
import * as __WEBPACK_EXTERNAL_MODULE__CdnIcon_index_js_4f7458e7__ from "../../CdnIcon/index.js";
import * as __WEBPACK_EXTERNAL_MODULE__utils_index_js_02c78a7f__ from "../../../utils/index.js";
import * as __WEBPACK_EXTERNAL_MODULE__Checkbox_variants_js_acedfa64__ from "./Checkbox.variants.js";
const Checkbox = (props)=>{
    const { emphasis, checkboxClassName, disabled = false, value, checked = false, indeterminate = false, handleChange, ref, size = '20', required, isCheckboxGroup = false, ...restProps } = props;
    const iconName = getIconName({
        checked,
        showIndeterminate: indeterminate
    });
    const { root, indicator, icon } = (0, __WEBPACK_EXTERNAL_MODULE__Checkbox_variants_js_acedfa64__.checkboxVariants)({
        size,
        emphasis,
        isCheckboxGroup
    });
    const onCheckedChange = (_ischecked, e)=>{
        if ('function' == typeof handleChange) handleChange(value, e);
    };
    const classes = (0, __WEBPACK_EXTERNAL_MODULE__utils_index_js_02c78a7f__.cn)(root(), checkboxClassName);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__base_ui_components_react_checkbox_ad80fa33__.Checkbox.Root, {
        indeterminate: indeterminate,
        disabled: disabled,
        checked: checked,
        onCheckedChange: onCheckedChange,
        className: classes,
        inputRef: ref,
        value: value,
        required: required,
        ...restProps,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__base_ui_components_react_checkbox_ad80fa33__.Checkbox.Indicator, {
            hidden: false,
            keepMounted: true,
            className: indicator(),
            children: iconName ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__CdnIcon_index_js_4f7458e7__.CdnIcon, {
                className: icon(),
                size: size,
                iconName: iconName
            }) : null
        })
    });
};
function getIconName({ checked, showIndeterminate }) {
    let iconName;
    if (checked && !showIndeterminate) iconName = 'check';
    if (showIndeterminate) iconName = 'check_indeterminate_small';
    return iconName;
}
export { Checkbox };
